export const formatSar = (amount) =>
  `SAR ${Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const formatCount = (value) =>
  Number(value || 0).toLocaleString("en-US");

export const formatRate = (percent) =>
  `${Math.abs(Number(percent) || 0).toFixed(1)}%`;

export const changeTone = (direction) => {
  if (direction === "down") {
    return { color: "danger", icon: "mdi-menu-down" };
  }
  if (direction === "flat") {
    return { color: "secondary", icon: "mdi-minus" };
  }
  return { color: "success", icon: "mdi-menu-up" };
};
